import { Term } from "@/components/molecules/Term";
import { Form } from "@/components/organisms/Form";
import { Buttons } from "@/components/atoms/Buttons";
import { UseTerms } from "@/data/terms";
import { agreeState } from "@/common/states/agree";
import { useNavigate } from "react-router";
import { JoinTemplate } from "@/components/templates/JoinTemplate";
import { InputCheckbox } from "@/components/atoms/Inputs/InputCheckbox";
import { useRecoilState } from "recoil";
import { JoinProcessBar } from "@/components/atoms/JoinProcessBar";

export const AgreeUsePage = () => {
  const navigate = useNavigate();
  const [agree, setAgree] = useRecoilState(agreeState);
  const isChecked = !!agree?.agreementTime2;

  return (
    <JoinTemplate>
      <Form
        processBar={<JoinProcessBar stepNow={3} stepTotal={6} />}
        title="개인정보 수집・이용 및 제3자 제공 동의"
        text={
          <>
            본 서비스를 이용하기 위해서는 아래 개인정보 수집&middot;이용 및
            <br />
            제3자 제공에 대한 동의가 필요합니다.
          </>
        }
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            color="primary100"
            layout="solid"
            label="다음"
            disabled={!isChecked}
            onClick={() => {
              navigate("/auth/join/account-form");
            }}
          />
        }
        backBtn={
          <Buttons
            type="button"
            size="lg"
            color="primary100"
            layout="text"
            label="뒤로"
            onClick={() => navigate("/auth/join/agree-attend")}
          />
        }
      >
        <Term
          processBar={true}
          text={<UseTerms />}
          checkbox={
            <InputCheckbox
              size="lg"
              name="atend-agree"
              data={[
                {
                  id: 1,
                  value: "",
                  displayExpr:
                    "개인정보 수집・이용 및 제3자 제공에 동의합니다.",
                },
              ]}
              onChange={(e) => {
                setAgree((prev) => ({
                  ...prev,
                  agreementTime2: e.target.checked ? new Date() : null,
                }));
              }}
              value={isChecked}
            />
          }
        />
      </Form>
    </JoinTemplate>
  );
};
